(() => {
  const root=document.documentElement;
  const allowed='[data-scroll-pane],#searchResults,#libraryList,#preset-rows,#preset-inspector,#update-view,#module-view';
  document.addEventListener('wheel',event=>{
    let node=event.target instanceof Element?event.target:null;
    while(node && node!==document.body){
      if(node.matches(allowed)){
        const style=getComputedStyle(node);
        const vertical=/(auto|scroll)/.test(style.overflowY) && ((event.deltaY<0&&node.scrollTop>0)||(event.deltaY>0&&node.scrollTop+node.clientHeight<node.scrollHeight-1));
        const horizontal=/(auto|scroll)/.test(style.overflowX) && ((event.deltaX<0&&node.scrollLeft>0)||(event.deltaX>0&&node.scrollLeft+node.clientWidth<node.scrollWidth-1));
        if(vertical||horizontal)return;
      }
      node=node.parentElement;
    }
    event.preventDefault();
  },{passive:false,capture:true});
  document.addEventListener('scroll',()=>{if(root.scrollTop||root.scrollLeft||document.body.scrollTop||document.body.scrollLeft)window.scrollTo(0,0)},true);
  document.querySelectorAll('.q').forEach(button=>{
    button.addEventListener('pointerdown',()=>button.classList.add('is-pressed'));
    for(const type of ['pointerup','pointercancel','pointerleave'])button.addEventListener(type,()=>setTimeout(()=>button.classList.remove('is-pressed'),55));
  });
  for(const panel of document.querySelectorAll('.panel')){
    panel.addEventListener('pointermove',e=>{const r=panel.getBoundingClientRect();panel.style.setProperty('--mx',(e.clientX-r.left)+'px');panel.style.setProperty('--my',(e.clientY-r.top)+'px')});
    panel.addEventListener('pointerleave',()=>{panel.style.setProperty('--mx','50%');panel.style.setProperty('--my','50%')});
  }
})();
